/**
 * @generated SignedSource<<6108cee85dce6e7fe6fc9c0cfc98efb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HsDeleteConnectionInput = {
  clientMutationId?: string | null | undefined;
  removeContacts?: boolean | null | undefined;
};
export type Integration_HubspotDeleteConnection_Mutation$variables = {
  input: HsDeleteConnectionInput;
};
export type Integration_HubspotDeleteConnection_Mutation$data = {
  readonly hsDeleteConnection: {
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type Integration_HubspotDeleteConnection_Mutation = {
  response: Integration_HubspotDeleteConnection_Mutation$data;
  variables: Integration_HubspotDeleteConnection_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HsDeleteConnectionPayload",
    "kind": "LinkedField",
    "name": "hsDeleteConnection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_HubspotDeleteConnection_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_HubspotDeleteConnection_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ee67fc6e56d23f17e564bafda1ce7a3",
    "id": null,
    "metadata": {},
    "name": "Integration_HubspotDeleteConnection_Mutation",
    "operationKind": "mutation",
    "text": "mutation Integration_HubspotDeleteConnection_Mutation(\n  $input: HsDeleteConnectionInput!\n) {\n  hsDeleteConnection(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "5241d5e87140bad565777aa47df1712b";

export default node;
